import React from 'react';
import PortfolioGalleryCommon from '../../layouts-components__common-cases/portfolio-gallery';
import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const imgList = [
    '/images/pic/letovo/gallery1.jpg',
    '/images/pic/letovo/gallery2.jpg',
    '/images/pic/letovo/gallery3.jpg',
    '/images/pic/letovo/gallery4.jpg',
    '/images/pic/letovo/gallery5.jpg',
    '/images/pic/letovo/gallery6.jpg',
    '/images/pic/letovo/gallery7.jpg',
    '/images/pic/letovo/gallery8.jpg',
    '/images/pic/letovo/gallery9.jpg',
    '/images/pic/letovo/gallery10.jpg',
    '/images/pic/letovo/gallery11.jpg',
    '/images/pic/letovo/gallery12.jpg',
    '/images/pic/letovo/gallery13.jpg',
];

const PortfolioGallery = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <PortfolioGalleryCommon
                imgList={imgList}
                className="letovo-portfolio-gallery"
                isMargin={true}
                smallPaddings={true}
            />
        </ScrollAnimation>
    );
};

export default PortfolioGallery;
